module.exports = __webpack_public_path__ + "static/media/phone.70d38c8a.png";